
import { ApplicationUserModel, ProductModel } from '@/libs/Api';
import { CrudAction, CrudReponse } from '@/libs/core/+state/models/crud-action';
import { CrudGetter } from '@/libs/core/+state/models/crud-getter';
import Page from '@/Page.vue';
import { Component, Prop, Ref, Watch } from 'vue-property-decorator';
import { applicationUserStore } from '@/libs/user-settings/+state/store';
import { Guid } from '@/libs/common/functions/guid';
import { productsStore } from '@/libs/products/+state/store';
import ProjectSelect from '@/libs/common/components-smart/ProjectSelect.vue';
import ProductScrapReasonList from '@/libs/settings/components/ProductScrapReasonList.vue';

@Component({
    components: { ProductScrapReasonList, ProjectSelect },
})
export default class ProductDialog extends Page {
    id!: string;
    dialog = false;
    valid = true;
    saving = false;
    loading = false;
    applicationUser: ApplicationUserModel = applicationUserStore.useGetter(CrudGetter.Detail) as ApplicationUserModel;
    product: ProductModel | null = null;
    deleteDialog = false;
    deleting = false;

    @Ref() form!: any;

    get isNewItem(): boolean {
        return this.product?.id == Guid.EmptyGuid();
    }

    open(id: string) {
        this.dialog = true;
        this.id = id;
        this.load();
    }

    close() {
        this.dialog = false;
    }

    private load(): Promise<any> {
        if (this.id != Guid.EmptyGuid()) {
            this.loading = true;
            return new Promise((resolve, reject) => {
                this.loadProduct()
                    .then((e) => {
                        this.loading = false;
                        resolve(e);
                    })
                    .catch((e: any) => {
                        reject(e);
                    });
            });
        } else {
            this.product = {
                id: Guid.EmptyGuid(),
                code: '',
                name: '',
                projectId: undefined,
                productScrapReasons: [],
            } as ProductModel;
            return new Promise((resolve, reject) => {
                resolve(null);
            });
        }
    }

    private loadProduct() {
        return new Promise((resolve, reject) => {
            productsStore.dispatch(CrudAction.Get, { id: this.id });
            this.subscribe(productsStore, CrudReponse.Get)
                .then((e) => {
                    this.product = e;
                    resolve(e);
                })
                .catch((e: any) => {
                    reject(e);
                });
        });
    }

    private save() {
        if (this.form.validate()) {
            const product = { ...this.product };
            this.saving = true;
            if (this.id == Guid.EmptyGuid()) {
                productsStore.dispatch(CrudAction.Create, { item: product });
                this.subscribe(productsStore, CrudReponse.Create)
                    .then(() => {
                        this.load().then(() => {
                            this.saving = false;
                            this.close();
                        });
                    })
                    .catch((e) => {
                        this.saving = false;
                        throw e;
                    });
            } else {
                productsStore.dispatch(CrudAction.Update, { item: product });
                this.subscribe(productsStore, CrudReponse.Update)
                    .then(() => {
                        this.load().then(() => {
                            this.saving = false;
                            this.close();
                        });
                    })
                    .catch((e) => {
                        this.saving = false;
                        throw e;
                    });
            }
        }
    }

    deleteClick() {
        this.deleteDialog = true;
    }

    deleteProduct() {
        this.deleting = true;
        productsStore.dispatch(CrudAction.Delete, { id: this.id });
        this.subscribe(productsStore, CrudReponse.Delete)
            .then((e: any) => {
                this.deleting = false;
                this.deleteDialog = false;
                this.close();
            })
            .catch((e: any) => {
                this.deleting = false;
            });
    }
}
